import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "max-w-lg max-h-lg" }
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/_createTextVNode("다운로드")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("닫기")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.mediaType === 'image')
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: _ctx.src,
          class: "hover:brightness-75 cursor-pointer transition-all max-h-28",
          alt: "targetFace",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleModal && _ctx.toggleModal(...args)))
        }, null, 8, _hoisted_1))
      : (_openBlock(), _createElementBlock("video", {
          key: 1,
          src: _ctx.src,
          class: "hover:brightness-75 cursor-pointer transition-all max-h-28",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleModal && _ctx.toggleModal(...args)))
        }, null, 8, _hoisted_2)),
    _createVNode(_component_a_modal, {
      visible: _ctx.isOpenModal,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isOpenModal) = $event)),
      closable: false,
      title: _ctx.mediaType === 'image' ? '이미지' : '동영상'
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_a_button, { onClick: _ctx.download }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: _ctx.toggleModal
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          (_ctx.mediaType === 'image')
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                class: "w-full h-auto",
                src: _ctx.src,
                alt: "targetFace"
              }, null, 8, _hoisted_4))
            : (_openBlock(), _createElementBlock("video", {
                key: 1,
                class: "w-full h-auto",
                src: _ctx.src,
                controls: "",
                controlsList: "nodownload"
              }, null, 8, _hoisted_5))
        ])
      ]),
      _: 1
    }, 8, ["visible", "title"])
  ], 64))
}